import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setExtra } from "@sentry/react";

type BankDocument = {
  name: string;
  file: string;
  doc?: File | null;
  id: string;
};

type CreateRefundOrderState = {
  reason: string;
  otherReason: string;
  AD_ref_no: string;
  purpose: string;
  sender_name: string;
  documents: {}[];
  bank_document: BankDocument[];
  amount_sent: string;
  refundable_amount: string;
  settlement_rate: string;
  my_margin: string;
  partner_margin: string;
  refund_id: string;
  refund_status: string;
  purpose_id: string;
  order_id: string;
  currency: string;
  service_partner_id: string;
  created_by: string;
  deal_id: string;
  tt_rate: string;
  foreign_bank_rate: string;
  service_partner_bank_id: string;
  partner_order_id: string;
  extra_document: any[];
};

export const initialState: CreateRefundOrderState = {
  extra_document: [],
  partner_order_id: "",
  service_partner_bank_id: "",
  deal_id: "",
  service_partner_id: "",
  created_by: "",
  order_id: "",
  purpose_id: "",
  reason: "",
  otherReason: "",
  AD_ref_no: "",
  purpose: "",
  sender_name: "",
  documents: [],
  bank_document: [],
  amount_sent: "",
  refundable_amount: "",
  settlement_rate: "",
  my_margin: "",
  partner_margin: "",
  refund_id: "",
  refund_status: "",
  currency: "",
  tt_rate: "",
  foreign_bank_rate: "",
};

export const CreateRefundOrderSlice = createSlice({
  name: "CreateRefundOrder",
  initialState,
  reducers: {
    setServicePartnerBankId: (state, action: PayloadAction<string>) => {
      state.service_partner_bank_id = action.payload;
    },
    setRefundTTRate: (state, action: PayloadAction<string>) => {
      state.tt_rate = action.payload;
    },
    setRefundForeignBankRate: (state, action: PayloadAction<string>) => {
      state.foreign_bank_rate = action.payload;
    },
    setOrderId: (state, action: PayloadAction<string>) => {
      state.order_id = action.payload;
    },
    setDealId: (state, action: PayloadAction<string>) => {
      state.deal_id = action.payload;
    },
    setServicePartnerId: (state, action: PayloadAction<string>) => {
      state.service_partner_id = action.payload;
    },
    setCreatedBy: (state, action: PayloadAction<string>) => {
      state.created_by = action.payload;
    },
    setPurposeId: (state, action: PayloadAction<string>) => {
      state.purpose_id = action.payload;
    },
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
    setReason: (state, action: PayloadAction<string>) => {
      state.reason = action.payload;
    },
    setOtherReason: (state, action: PayloadAction<string>) => {
      state.otherReason = action.payload;
    },
    setADRefNo: (state, action: PayloadAction<string>) => {
      state.AD_ref_no = action.payload;
    },
    setPurpose: (state, action: PayloadAction<string>) => {
      state.purpose = action.payload;
    },
    setSenderName: (state, action: PayloadAction<string>) => {
      state.sender_name = action.payload;
    },
    setPartnerOrderId: (state, action: PayloadAction<string>) => {
      state.partner_order_id = action.payload;
    },
    setDocuments: (
      state,
      action: PayloadAction<{ [key: string]: string | number }[]>,
    ) => {
      state.documents = action.payload;
    },
    setBankDocument: (state, action: PayloadAction<BankDocument[]>) => {
      state.bank_document = action.payload;
    },
    setAmountSent: (state, action: PayloadAction<string>) => {
      state.amount_sent = action.payload;
    },
    setRefundableAmount: (state, action: PayloadAction<string>) => {
      state.refundable_amount = action.payload;
    },
    setRefundSettlementRate: (state, action: PayloadAction<string>) => {
      state.settlement_rate = action.payload;
    },
    setMyMargin: (state, action: PayloadAction<string>) => {
      state.my_margin = action.payload;
    },
    setPartnerMargin: (state, action: PayloadAction<string>) => {
      state.partner_margin = action.payload;
    },
    setRefundId: (state, action: PayloadAction<string>) => {
      state.refund_id = action.payload;
    },
    setRefundStatus: (state, action: PayloadAction<string>) => {
      state.refund_status = action.payload;
    },
    setExtraDocument: (state, action: PayloadAction<any[]>) => {
      state.extra_document = action.payload;
    },
    resetRefundOrder: (state) => {
      const refund_id = state.refund_id;
      return {
        ...initialState,
        refund_id: refund_id,
      };
    },
  },
});

export const {
  setExtraDocument,
  setPartnerOrderId,
  setRefundTTRate,
  setServicePartnerBankId,
  setRefundForeignBankRate,
  setServicePartnerId,
  setCreatedBy,
  setReason,
  setOtherReason,
  setADRefNo,
  setPurpose,
  setSenderName,
  setCurrency,
  setDocuments,
  setBankDocument,
  setAmountSent,
  setDealId,
  setRefundableAmount,
  setRefundSettlementRate,
  setMyMargin,
  setPartnerMargin,
  setRefundId,
  setRefundStatus,
  setPurposeId,
  setOrderId,
  resetRefundOrder,
} = CreateRefundOrderSlice.actions;

export default CreateRefundOrderSlice.reducer;
